<svg 
    [ngClass]="IconClass"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 13 14">
    <path d="M6 6.953l4.266 4.266q-0.828 0.844-1.934 1.313t-2.332 0.469q-1.633 0-3.012-0.805t-2.184-2.184-0.805-3.012 0.805-3.012 2.184-2.184 3.012-0.805v5.953zM7.461 7h6.039q0 1.227-0.469 2.332t-1.313 1.934zM13 6h-6v-6q1.633 0 3.012 0.805t2.184 2.184 0.805 3.012z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-pie-chart.html